$(document).ready(function () {

    $(".contact-table").on('click', '.edit', function (e) {
        e.preventDefault();
        let url = window.config.urls.contacts.editForm;
        let id = $(this).attr('data-id');

        window.axios.post(url + '/' + id, {id})
            .then(({data: result}) => {
                if (result)
                    $('#edit-fields').html(result);
                else
                    displayError();
            })
            .catch((error) => {
                displayError();
            });
    });

    $(".business-unit-table").on('click', '.edit', function (e) {
        e.preventDefault();
        let url = window.config.urls.business_units.editForm;
        let id = $(this).attr('data-id');
        window.axios.post(url + '/' + id, {id})
            .then(({data: result}) => {
                if (result) {
                    $('#edit-fields').html(result);
                }

                if (!result.success) {
                    console.log('Could not load contact');
                }
            });
    });
});

function displayError() {
    let errorOccurred = window.config.language.errorOccurred;
    let alert = '<div class="alert alert-danger" role="alert">' + errorOccurred + '</div>';
    $('#edit-fields').html(alert);
}
